document.addEventListener("DOMContentLoaded", function () {
  console.clear();
  let desktop_product_information_container = document.querySelector('.wim-product-information__container-desktop .product-information--inner');
  let mobile_product_information_container = document.querySelector('.wim-product-information__container-mobile');
  if (desktop_product_information_container && mobile_product_information_container) {
    if (window.innerWidth < 1068 && desktop_product_information_container.innerHTML.trim() !== '') {
      mobile_product_information_container.innerHTML = desktop_product_information_container.innerHTML;
      desktop_product_information_container.innerHTML = '';
      mobile_product_information_container.classList.add('product-information');
    }
    else if (window.innerWidth >= 1068 && mobile_product_information_container.innerHTML.trim() !== '') {
      desktop_product_information_container.innerHTML = mobile_product_information_container.innerHTML;
      mobile_product_information_container.innerHTML = '';
      mobile_product_information_container.classList.remove('product-information');
    }
  }
  const mobileMenu = document.getElementById("mobile-menu");
  if (mobileMenu.classList.contains("wim-mobile-menu-drawer")) {
    const mobileMenuTabs = mobileMenu.querySelectorAll(".mobile-menu__tabs button");
    const mobileMenuContents = mobileMenu.querySelectorAll(".mobile-menu__tab-content");

    mobileMenuTabs.forEach(tab => {
      tab.addEventListener("click", function () {
        const targetTab = this.getAttribute("data-tab");

        mobileMenuTabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");

        mobileMenuContents.forEach(content => {
          content.classList.remove("active");
          if (content.getAttribute("data-tab") === targetTab) {
            content.classList.add("active");
          }
        });
      });
    });
  }
  const fullMenu = document.querySelector(".wim-full-menu");
  if (fullMenu) {
    const fullMenuTabs = fullMenu.querySelectorAll(".desktop-menu__tabs button");
    const fullMenuContents = fullMenu.querySelectorAll(".desktop-menu__content li");

    fullMenuTabs.forEach(tab => {
      tab.addEventListener("click", function () {
        const targetTab = this.getAttribute("data-tab");

        fullMenuTabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");

        fullMenuContents.forEach(content => {
          content.classList.remove("active");
          if (content.getAttribute("data-tab") === targetTab) {
            content.classList.add("active");
          }
        });
      });
    });
  }
  const closeFullMenuButton = document.querySelector(".wim-header .desktop-menu__close-button");
  if (closeFullMenuButton) {
    closeFullMenuButton.addEventListener("click", function () {
      document.querySelector(".wim-header #header").classList.remove("open-menu");
    });
  }
  const timeline = document.querySelector('.wim-timeline-vertical');
  const items = document.querySelectorAll('.timeline-vertical__item');

  let timelineVisible = false;

  // Observer para el contenedor principal
  const timelineObserver = new IntersectionObserver((entries) => {
    timelineVisible = entries[0].isIntersecting;
  }, { threshold: 0.1 });

  if (timeline) {
    timelineObserver.observe(timeline);
  }

  // Observer para los itemsP
  const itemObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (timelineVisible && entry.isIntersecting) {
        items.forEach(item => item.classList.remove('active'));
        entry.target.classList.add('active');
        // Marcar el siguiente
        const next = Array.from(items).find((el, idx, arr) => arr[idx - 1] === entry.target);
        if (!next) {
          // Si no se encuentra por arriba, buscar por abajo
          const idx = Array.from(items).indexOf(entry.target);
          if (items[idx + 1]) {
            items[idx + 1].classList.add('active');
          }
        } else {
          next.classList.add('active');
        }
      }
    });
  }, { threshold: 0.5 });

  items.forEach(item => {
    itemObserver.observe(item);
  });
  let toggleFiltersButton = document.querySelectorAll('.facets-popup-modal--tab-header-toggle');
  toggleFiltersButton.forEach(button => {
    button.addEventListener('click', function () {
      this.classList.toggle('active-toggle');
      document.querySelector(`#${this.getAttribute('data-target')}`).classList.toggle('tab-open');
    });
  });
  initScrollingTexts();
  initReadMoreContainers();

  let scrolling_box_extra_content_links = document.querySelectorAll('.scrolling-boxes--box-content-link--expand');

  scrolling_box_extra_content_links.forEach(link => {
    link.addEventListener('click', function (e) {
      let extra_content = document.querySelector(link.getAttribute('href'));
      if (extra_content) {
        extra_content.setAttribute('open', '');
      }
    });
  });
  let collection_category_menu_links = document.querySelectorAll('.wim-collection-categories .wim-item-collection-category__card--link');
  collection_category_menu_links.forEach(link => {
    link.addEventListener('click', function (e) {
      console.log(e);
      let submenu_id = link.getAttribute('data-submenu-id');
      if (submenu_id) {
        let submenu = document.getElementById(submenu_id);
        if (submenu) {
          document.querySelectorAll('.wim-collection-categories .wim-item-collection-category__card--link').forEach(item => {
            item.parentElement.parentElement.classList.remove('active');
          });
          document.querySelectorAll('.wim-collection-categories .wim-submenu-categories__item').forEach(item => {
            if (item.id !== submenu.id) {
              item.classList.remove('open');
            }
            else {
              item.classList.add('open');
              link.parentElement.parentElement.classList.add('active');
            }
          });
        }
      }
    });
  });
  let collection_grid_controls = document.querySelector('.wim-grid-controls');
  let collection_container_products = document.getElementById('product-grid');
  if (collection_grid_controls && collection_container_products) {
    const originalColumnsAttr = collection_grid_controls.getAttribute('data-all-columns');
    const originalColumnsArray = originalColumnsAttr.split(',');
    const originalColumns = {
      small: originalColumnsArray[0].split(':'),
      medium: originalColumnsArray[1].split(':'),
      large: originalColumnsArray[2].split(':'),
      xlarge: originalColumnsArray[3].split(':'),
    };
    const collection_grid_btns = collection_grid_controls.querySelectorAll('.wim-grid-control-btn');
    collection_grid_btns.forEach(button => {
      button.addEventListener('click', (e) => {
        const buttonGrid = e.currentTarget;

        if (!buttonGrid.classList.contains('active')) {

          gridButtonsHandler(buttonGrid, collection_container_products, originalColumns, collection_grid_btns);
        }
        else {
          return;
        }
      });
      if (window.innerWidth >= 1440 || (window.innerWidth >= 1200 && window.innerWidth < 1440)) {
        collection_container_products.classList.add('inspirational-style');
      }
      else {
        collection_container_products.classList.add('clasic-style');
      }
      if (window.innerWidth < 792 || (window.innerWidth >= 792 && window.innerWidth < 1068)) {
        if (button.dataset.type === 'medium-grid') {
          button.classList.add('hidden');
        }
        if (window.innerWidth < 792 && button.dataset.type === 'full-grid') {
          gridButtonsHandler(button, collection_container_products, originalColumns, collection_grid_btns);
        }
      }
      else {
        button.classList.remove('hidden');
      }
    });
  }
  let product_thunbnails_container = document.querySelector('.product-thumbnail-container.style-vertical');
  if (product_thunbnails_container) {

    const btnNext = product_thunbnails_container.querySelector('.btn-next');
    const btnPrev = product_thunbnails_container.querySelector('.btn-prev');

    btnNext.addEventListener('click', function () {
      const activeThumbnail = product_thunbnails_container.querySelector('.product-thumbnail.is-initial-selected');
      let nextThumbnail = activeThumbnail.nextElementSibling;
      if (nextThumbnail && nextThumbnail.classList.contains('product-thumbnail')) {
        nextThumbnail.click();
      }
    });
    btnPrev.addEventListener('click', function () {
      const activeThumbnail = product_thunbnails_container.querySelector('.product-thumbnail.is-initial-selected');
      let prevThumbnail = activeThumbnail.previousElementSibling;
      if (prevThumbnail && prevThumbnail.classList.contains('product-thumbnail')) {
        prevThumbnail.click();
      }
    });
  }
  let upsell_products_container = document.querySelectorAll('.wim-product-blocks--upsell-products');

  upsell_products_container.forEach(container => {
    container.querySelectorAll('.wim-product-card-upsell .product-featured-image').forEach(card => {
      card.addEventListener('click', function () {
        card.parentElement.classList.toggle('active');
        setTimeout(() => {
          let selected_upsell_products = [];
          document.querySelectorAll(`.wim-product-card-upsell.active[data-main-product-id="${card.parentElement.getAttribute('data-main-product-id')}"]`).forEach(otherCard => {
            if (!selected_upsell_products.includes(otherCard.getAttribute('data-product-variant-id'))) {
              selected_upsell_products.push(otherCard.getAttribute('data-product-variant-id'));
            };
          });
          let buy_buttons_block = document.querySelector(`.wim-product-blocks--buy-buttons[data-main-product-id="${card.parentElement.getAttribute('data-main-product-id')}"]`);
          if (buy_buttons_block) {
            buy_buttons_block.setAttribute('data-upsell-products', selected_upsell_products.join(','));
          }
        }, 300);
      });
    });
  });
  const dragThreshold = 12;

  console.log(document.querySelectorAll('.wim-collection-categories--menu, .wim-collection-categories--submenu .wim-submenu-categories__item'));
  document.querySelectorAll('.wim-collection-categories--menu, .wim-collection-categories--submenu .wim-submenu-categories__item').forEach((container) => {
    let isPointerDown = false;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let didDrag = false;

    const item_row = container.querySelector('.collection-grid.swipe-on-mobile');
    console.log(item_row);
    if (!item_row) return;

    item_row.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isPointerDown = true;
      didDrag = false;
      startX = e.clientX;
      startY = e.clientY;
      startScrollLeft = item_row.scrollLeft;
      // NO setPointerCapture aqui
    });

    item_row.addEventListener('pointermove', (e) => {
      console.log(e);
      if (!isPointerDown) return;
      if (e.pointerType === 'mouse' && e.buttons !== 1) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (!didDrag && Math.abs(dx) > dragThreshold && Math.abs(dx) > Math.abs(dy)) {
        didDrag = true;
        item_row.setPointerCapture(e.pointerId); // capturar solo cuando hay drag real
      }

      if (didDrag) {
        item_row.scrollLeft = startScrollLeft - dx;
      }
    });

    item_row.addEventListener('pointerup', (e) => {
      isPointerDown = false;
      if (didDrag) {
        item_row.releasePointerCapture(e.pointerId);
        const stopClick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          item_row.removeEventListener('click', stopClick, true);
          didDrag = false;
        };
        item_row.addEventListener('click', stopClick, true);
      }
    });

    item_row.addEventListener('pointercancel', () => {
      isPointerDown = false;
      didDrag = false;
    });
  });
});

window.addEventListener("resize", function () {
  initScrollingTexts();
  let desktop_product_information_container = document.querySelector('.wim-product-information__container-desktop .product-information--inner');
  let mobile_product_information_container = document.querySelector('.wim-product-information__container-mobile');
  if (desktop_product_information_container && mobile_product_information_container) {
    if (window.innerWidth < 1068 && desktop_product_information_container.innerHTML.trim() !== '') {
      mobile_product_information_container.classList.add('product-information');
      mobile_product_information_container.innerHTML = desktop_product_information_container.innerHTML;
      desktop_product_information_container.innerHTML = '';
    }
    else if (window.innerWidth >= 1068 && mobile_product_information_container.innerHTML.trim() !== '') {
      desktop_product_information_container.innerHTML = mobile_product_information_container.innerHTML;
      mobile_product_information_container.innerHTML = '';
      mobile_product_information_container.classList.remove('product-information');
    }
  }
});
function initScrollingTexts() {

  const wim_scrolling_text = document.querySelectorAll('.wim-section-scrolling-text');

  if (wim_scrolling_text.length > 0) {

    gsap.registerPlugin(Observer);
    wim_scrolling_text.forEach(section => {

      const containerItems = section.querySelector('.scrolling-text--inner');
      const sectionSpeed = section.getAttribute('data-speed') || 1;
      const sectionDirection = section.getAttribute('data-direction') === 'true' ? true : false;
      const scrollingTextItems = section.querySelectorAll('.scrolling-text--item');

      if (scrollingTextItems.length - 1 > 0) {

        if ((scrollingTextItems.length - 1) * 180 <= containerItems.clientWidth) {
          containerItems.style.setProperty('--width-scrolling-item', `${Math.floor(containerItems.clientWidth / (scrollingTextItems.length - 1))}px`);
        };
        const scrollingText = gsap.utils.toArray(scrollingTextItems);

        setTimeout(() => {
          section.querySelector('.scrolling-text--inner').classList.add('show');
          const horizontalLoopItem = horizontalLoop(scrollingText, {
            repeat: -1,
            reversed: sectionDirection,
            speed: sectionSpeed,
            paddingRight: 30,
          });
          // Observer.create({
          //   onChangeY(self) {
          //     let factor = 2.5;
          //     console.log(self);
          //     if (self.deltaY < 0) {
          //       factor *= -1;
          //     }
          //     gsap.timeline({ defaults: { ease: 'none' } })
          //       .to(horizontalLoopItem, { timeScale: 0, duration: 0.2, overwrite: true })
          //       .to(horizontalLoopItem, { timeScale: 0, duration: 1 }, '+=0.3');
          //   },
          // });
        }, 10 * scrollingTextItems.length);
      }
    });
  }
};
function horizontalLoop(items, config) {
  items = gsap.utils.toArray(items);
  config = config || {};
  let tl = gsap.timeline({
    repeat: config.repeat,
    paused: config.paused,
    defaults: { ease: 'none' },
    onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
  });
  let length = items.length,
    startX = items[0].offsetLeft,
    times = [],
    widths = [],
    xPercents = [],
    curIndex = 0,
    pixelsPerSecond = (config.speed || 1) * 100,
    snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
    totalWidth,
    curX,
    distanceToStart,
    distanceToLoop,
    item,
    i;
  gsap.set(items, {
    // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
    xPercent: (i, el) => {
      let w = (widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px')));
      xPercents[i] = snap(
        (parseFloat(gsap.getProperty(el, 'x', 'px')) / w) * 100 + gsap.getProperty(el, 'xPercent')
      );
      return xPercents[i];
    },
  });
  gsap.set(items, { x: 0 });
  totalWidth =
    items[length - 1].offsetLeft +
    (xPercents[length - 1] / 100) * widths[length - 1] -
    startX +
    items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') +
    (parseFloat(config.paddingRight) || 0);
  for (i = 0; i < length; i++) {
    item = items[i];
    curX = (xPercents[i] / 100) * widths[i];
    distanceToStart = item.offsetLeft + curX - startX;
    distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX');
    tl.to(item, { xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100), duration: distanceToLoop / pixelsPerSecond }, 0)
      .fromTo(item, { xPercent: snap(((curX - distanceToLoop + totalWidth) / widths[i]) * 100) }, { xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false, }, distanceToLoop / pixelsPerSecond)
      .add('label' + i, distanceToStart / pixelsPerSecond);
    times[i] = distanceToStart / pixelsPerSecond;
  }
  function toIndex(index, vars) {
    vars = vars || {};
    Math.abs(index - curIndex) > length / 2 && (index += index > curIndex ? -length : length); // always go in the shortest direction
    let newIndex = gsap.utils.wrap(0, length, index),
      time = times[newIndex];
    if (time > tl.time() !== index > curIndex) {
      // if we're wrapping the timeline's playhead, make the proper adjustments
      vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
      time += tl.duration() * (index > curIndex ? 1 : -1);
    }
    curIndex = newIndex;
    vars.overwrite = true;
    return tl.tweenTo(time, vars);
  }
  tl.next = (vars) => toIndex(curIndex + 1, vars);
  tl.previous = (vars) => toIndex(curIndex - 1, vars);
  tl.current = () => curIndex;
  tl.toIndex = (index, vars) => toIndex(index, vars);
  tl.times = times;
  tl.progress(1, true).progress(0, true); // pre-render for performance
  if (config.reversed) {
    tl.vars.onReverseComplete();
    tl.reverse();
  }
  return tl;
};
function gridButtonsHandler(buttonGrid, collection_container_products, originalColumns, collection_grid_btns) {
  const gridType = buttonGrid.dataset.type;
  const columns = buttonGrid.dataset.columns.split(',').map(col => col.split(':'));
  let class_columns = collection_container_products.className.split(' ');
  let change_column = {
    search: null,
    replace: null
  };
  let width_type = null;
  let grid_style = 'classic-style';
  let replace_value = null;
  if (window.innerWidth >= 1440) {
    width_type = 'xlarge';
    if (gridType === 'full-grid') {
      replace_value = columns[1][0];
      grid_style = 'inspirational-style';
    }
    else {
      replace_value = columns[0][0];
    }
  }
  else if (window.innerWidth >= 1200 && window.innerWidth < 1440) {
    width_type = 'large';
    if (gridType === 'full-grid') {
      grid_style = 'inspirational-style';
    }
    replace_value = columns[0][0];
  }
  else if (window.innerWidth >= 1068 && window.innerWidth < 1200) {
    width_type = 'large';
    if (gridType === 'full-grid') {
      replace_value = columns[0][1];
    }
    else {
      replace_value = columns[0][0];
    }
  }
  else if (window.innerWidth >= 792 && window.innerWidth < 1068) {
    width_type = 'medium';
    if (gridType === 'full-grid') {
      replace_value = 4;
    }
    else {
      replace_value = columns[0][0];
    }
  }
  else {
    width_type = 'small';
    if (gridType === 'full-grid') {
      replace_value = 4;
      grid_style = 'inspirational-style';
    }
    else {
      replace_value = columns[0][0];
    }
  }
  change_column.search = `${width_type}-up-`;
  change_column.replace = `${width_type}-up-${replace_value}`;

  if (gridType === 'full-grid' && window.innerWidth >= 1440) {
    change_column.search = 'xlarge-up-';
    change_column.replace = `xlarge-up-${replace_value}`;
    grid_style = 'inspirational-style';
  }
  else if (gridType === 'full-grid' && window.innerWidth >= 1068 && window.innerWidth < 1440) {
    change_column.search = 'large-up-';
    change_column.replace = `large-up-${replace_value}`;
    grid_style = 'inspirational-style';
  }
  if (change_column.search && change_column.replace) {
    class_columns = class_columns.reduce((previous_item, current_item) => {
      if (current_item.includes(change_column.search)) {
        previous_item.push(change_column.replace);
      }
      else if (current_item.includes('-up-')) {
        let type_col = current_item.split('-up-')[0];
        if (type_col == 'large' && window.innerWidth >= 1200 && window.innerWidth < 1440) {
          previous_item.push(`${current_item.split('-up-')[0]}-up-${originalColumns[current_item.split('-up-')[0]][0][0]}`);
        }
        else if (type_col == 'large' && window.innerWidth >= 1068 && window.innerWidth < 1200) {
          previous_item.push(`${current_item.split('-up-')[0]}-up-${originalColumns[current_item.split('-up-')[0]][0][1]}`);
        }
        else {
          previous_item.push(`${current_item.split('-up-')[0]}-up-${originalColumns[current_item.split('-up-')[0]][0]}`);
        }
      }
      else if (!['inspirational-style', 'classic-style'].includes(current_item.trim()) && current_item.trim() !== '') {
        previous_item.push(current_item);
      }
      return previous_item;
    }, []);
    collection_container_products.className = `${class_columns.join(' ')} ${grid_style}`;
    collection_container_products.setAttribute('active-view', gridType);
  }
  collection_grid_btns.forEach(btn => btn.classList.remove('active'));
  buttonGrid.classList.add('active');
};
function initReadMoreContainers() {
  document.querySelectorAll('.wim-read-more__container').forEach(container => {
    const content = container.querySelector('.wim-read-more__content');
    const button = container.querySelector('.wim-read-more__btn');

    if (!content || !button) return;

    const spanReadMore = button.querySelector('.wim-read-more__text');
    const spanReadLess = button.querySelector('.wim-read-less__text');

    if (!spanReadMore || !spanReadLess) return;

    const maxVisibleLines = parseInt(content.dataset.chunkLines, 10) || 10;

    const lineHeight = parseFloat(getComputedStyle(content).lineHeight);

    const maxHeight = maxVisibleLines * lineHeight;

    const contentHeight = content.scrollHeight;

    let visibleMarginBottom = 0;
    let accumulatedHeight = 0;

    content.childNodes.forEach(child => {
      if (child.nodeType === 1) {
        const childHeight = child.offsetHeight;
        const childMarginBottom = parseFloat(getComputedStyle(child).marginBottom) || 0;

        accumulatedHeight += childHeight;

        if (accumulatedHeight <= maxHeight) {
          visibleMarginBottom += childMarginBottom;
        }
      }
    });

    const adjustedMaxHeight = maxHeight + visibleMarginBottom;

    const totalLines = Math.ceil(contentHeight / lineHeight);

    if (totalLines > maxVisibleLines) {
      button.style.display = 'inline-block';

      button.addEventListener('click', function () {
        const isExpanded = content.classList.toggle('expanded');
        let get_scroll_position = window.scrollY;
        if (isExpanded) {
          content.style.maxHeight = `${contentHeight}px`;
          spanReadMore.style.display = 'none';
          spanReadLess.style.display = 'inline';
          content.setAttribute('aria-expanded', 'true');
        } else {
          content.style.maxHeight = `${adjustedMaxHeight}px`;
          spanReadMore.style.display = 'inline';
          spanReadLess.style.display = 'none';
          content.setAttribute('aria-expanded', 'false');
          window.scrollTo({ top: get_scroll_position, behavior: 'smooth' });
        }
      });

      content.style.maxHeight = `${adjustedMaxHeight}px`;
    } else {
      button.style.display = 'none';
      content.setAttribute('aria-expanded', 'true');
    }
  });
};
function activeCustomer(shopifyClient) {

  if (document.querySelector('.container-form--active-customer-app-block')) {
    console.log("lanzado activeCustomer");
    /*
      Form Shopify App: la ejecucion de estos formularios es un poco compleja debido a que no es la etiqueta form
      la que envia los datos, sino que se utiliza fetch para enviar los datos a una url especifica
      Esta url: https://forms.shopifyapps.com/api/v2/form_submission
      Es la que realmente envia los datos del formulario de la app por lo tanto se creo una funcion que 
      intercepta los fetch de la pagina para poder ejecutar la consulta GraphQL en el momento indicado
      la idea es que cuando se envie el fetch de la url indicada, se ejecute la funcion customerRecover
      del cliente de Shopify Storefront API para que envie el email de recuperacion de contraseña si fuese el caso
      ya el formulario de la app se encarga de enviar el email de activacion de cuenta si fuese el caso, 
      esto por medio de un flujo en la app Shopify Flow
      Importante: no solo la url es importante, tambien el metodo debe ser POST y el body debe ser un string JSON,
      debido a que existe otra consulta que se hace con la misma url y el body es un FormData, que no permite obtener
      el email
      Para mas informacion sobre la consulta GraphQL customerRecover ver el archivo wim-storefront.js
    */
    const originalFetch = window.fetch;
    window.fetch = function (...args) {

      return originalFetch.apply(this, args).then((response) => {
        const [url, options] = args;
        if (
          url === 'https://forms.shopifyapps.com/api/v2/form_submission' &&
          options.method === 'POST' &&
          typeof options.body === 'string'
        ) {
          try {
            document.getElementById('recover-title').style.display = 'none';
            document.getElementById('recover-subtitle').style.display = 'none';
            let body_json = JSON.parse(options.body);
            if (body_json && body_json?.email) {
              shopifyClient.customerRecover(body_json.email).then((res) => {
                console.log('Recovery email sent:', res);
                setTimeout(() => {
                  window.location.href = '/account/login';
                }, 20000);
              });
            }
          } catch (error) {
            console.error('Error occurred while sending recovery email:', error);
          }
        }
        return response;
      });
    };
  }
}
(function injectShopifyFormEmbedStyles() {
  const TARGET_SELECTOR = 'shopify-forms-embed';
  const CSS = `
    input {
      border: 1px solid var(--color-form-border);
      padding: 12px 17px;
      height: 48px;
      margin-bottom: 10px;
      color: var(--color-body);
      font-size: .8125rem;
      font-weight: 400;
      background: var(--bg-body);
      max-width: 100%;
      border-radius: var(--input-border-radius, 3px) !important;
      -webkit-appearance: none !important;
      appearance: none;
      height: fit-content;
      padding: 12px 17px;
    }
    button {
      display: inline-flex;
      cursor: pointer;
      padding: 6px 30px;
      align-items: center;
      justify-content: center;
      height: 46px;
      font-size: .8125rem;
      font-weight: var(--font-body-medium-weight, 500);
      letter-spacing: var(--button-letter-spacing);
      border: 1px solid var(--solid-button-background, var(--color-accent));
      background: var(--solid-button-background, var(--color-accent));
      color: var(--solid-button-label, #fff);
      border-radius: var(--button-border-radius, 3px);
      text-align: center;
      position: relative;
      z-index: 1;
      overflow: hidden;
      transition: border .25s cubic-bezier(.68,.01,.33,.97),color .25s cubic-bezier(.68,.01,.33,.97),background .25s cubic-bezier(.68,.01,.33,.97),transform .5s cubic-bezier(.19,1,.22,1);
      -webkit-appearance: none;
      appearance: none;
    }
    form > div input[type="date"]:focus + label, form > div input[type="date"]:not(:placeholder-shown) + label, form > div input[type="datetime"]:focus + label, form > div input[type="datetime"]:not(:placeholder-shown) + label, form > div input[type="email"]:focus + label, form > div input[type="email"]:not(:placeholder-shown) + label, form > div input[type="number"]:focus + label, form > div input[type="number"]:not(:placeholder-shown) + label, form > div input[type="password"]:focus + label, form > div input[type="password"]:not(:placeholder-shown) + label, form > div input[type="search"]:focus + label, form > div input[type="search"]:not(:placeholder-shown) + label, form > div input[type="tel"]:focus + label, form > div input[type="tel"]:not(:placeholder-shown) + label, form > div input[type="text"]:focus + label, form > div input[type="text"]:not(:placeholder-shown) + label, form > div input[type="time"]:focus + label, form > div input[type="time"]:not(:placeholder-shown) + label, form > div input[type="url"]:focus + label, form > div input[type="url"]:not(:placeholder-shown) + label, form > div select:focus + label, form > div select:not(:placeholder-shown) + label, form > div textarea:focus + label, form > div textarea:not(:placeholder-shown) + label {
      top: 0 !important;
      background-color: white !important;
      padding: 1px 6px !important;
      width: fit-content !important;
    }
  `;
  function tryInject(el) {
    try {
      if (!el || el.dataset.wimInjected) return;
      const sr = el.shadowRoot;
      if (!sr) return;
      const style = document.createElement('style');
      style.setAttribute('data-wim-inject', 'true');
      style.textContent = CSS;
      sr.appendChild(style);
      sr.querySelector('button[type="submit"]').classList.add('btn', 'btn--primary');
      sr.querySelector('button[type="submit"]').innerHTML = `<span class="btn__text">${sr.querySelector('button[type="submit"]').textContent}</span>`;
      el.dataset.wimInjected = '1';

      const shopifyClient = new ShopifyStorefrontClient();
      activeCustomer(shopifyClient);
    } catch (e) {
      console.error('[wim] error injecting styles into shadowRoot', e);
    }
  }

  // Inject into any existing embeds
  document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);

  // Observe DOM for new embeds
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && node.matches(TARGET_SELECTOR)) tryInject(node);
        const descendants = node.querySelectorAll ? node.querySelectorAll(TARGET_SELECTOR) : [];
        descendants.forEach(tryInject);
      }
    }
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });

  // Retry pass for late-initialized shadowRoots (safety)
  let retries = 0;
  const maxRetries = 10;
  const retryInterval = setInterval(() => {
    document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);
    retries++;
    if (retries >= maxRetries) clearInterval(retryInterval);
  }, 500);
})();